import { useTranslations } from 'next-intl'

import { Tabs } from './tabs'
import { getTabOptions } from '../../lib/tab'

const MobileTabs = () => {
  const t = useTranslations('room_detail')

  const { TABS } = getTabOptions(t)

  return <Tabs tabs={TABS} isMobile />
}

export { Tabs, MobileTabs }
